module.exports = __webpack_public_path__ + "img/pirate.74506279.png";